import React, { useState, useEffect, useContext } from "react";

import Table from "../../common/Table";

import { Link } from "react-router-dom";

import db from "../../../services/query";
import { HalfYearContext } from "../../../contexts/halfYearContext";

const StudentFees = ({halfYearId}) => {
  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "faculty_name",
      label: "پوهنحی",
      content: (e) => (
        <Link to={`/mis/students/fees/faculties/${e.faculty_id}/classes`}>
          {e.faculty_name}
        </Link>
      ),
    },
    { path: "student_count", label: "تعداد محصل" },
    { path: "total_fee", label: "مجموع فیس" },
    { path: "discount", label: "تخفیف" },
    { path: "payable", label: "قابل دریافت" },
    { path: "paid", label: "دریافت شده" },
    { path: "balance", label: "باقی‌مانده" },
    { path: "current_overall_balance", label: "باقی‌مانده کل" },
    { path: "option" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `students/fees/faculties?halfYearId=${halfYearId || halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return <Table data={data} columns={columns} />;
};

export default StudentFees;
